import React from "react";

import {
  FaLayerGroup,
  FaLink,
  FaUnlink,
  FaUsers,
} from "react-icons/fa";

import CompactStat from "../ui/CompactStat";

export default function ActeursHeader({
  stats,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Administration
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              Gestion des acteurs
            </h1>

            <p className="mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-300">
              Gérez les acteurs du judo, leurs
              groupes et leur association à un
              compte utilisateur pour l’envoi
              des convocations.
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 xl:min-w-[820px] xl:grid-cols-4">
            <CompactStat
              icon={<FaUsers />}
              label="Acteurs"
              value={stats.total}
              accent="indigo"
            />

            <CompactStat
              icon={<FaLayerGroup />}
              label="Avec groupe"
              value={stats.withGroup}
              accent="emerald"
            />

            <CompactStat
              icon={<FaLink />}
              label="Avec compte"
              value={stats.linked}
              accent="indigo"
            />

            <CompactStat
              icon={<FaUnlink />}
              label="Sans compte"
              value={stats.unlinked}
              accent="amber"
            />
          </div>
        </div>
      </div>
    </div>
  );
}